import React from 'react'
import { Link } from 'gatsby'

import * as classes from './languageselector.module.scss'

export default function LanguageSelector() {
    return (
        <div className={classes.LanguageSelector}>
            <Link to="/en">EN</Link> / <Link to="/nl">NL</Link>
        </div>
    )
}